import { MoreBar, TableWidget } from '@revolut-internal/ui-kit'

import { AddInbox } from './AddInbox'

export const InboxesActions = () => {
  return (
    <TableWidget.Actions>
      <MoreBar>
        <AddInbox />
      </MoreBar>
    </TableWidget.Actions>
  )
}
